import { ColumnDef } from "@tanstack/react-table"
import { InvoicesHistoryData } from "@/types"

import { currenciesMap } from "@/components/invoiceArea/currencies"
import { formatPrice } from "@/utils"
import { InvoiceArchiveTableRowActions } from "./ArchiveInvoiceRowActions"
import { DataTableColumnHeader } from "@/shared/table/TableColumnHeader"

export const archivedInvoicesColumns: ColumnDef<InvoicesHistoryData>[] = [
    {
        id: "select",
        header: ({ table }) => (
            <label style={{ display: "flex", width: "100%", justifyContent: "center", cursor: "pointer", border: "none", boxShadow: "none" }}>
                <input
                    checked={table.getIsAllPageRowsSelected()}
                    aria-label="Select all"
                    type="checkbox"
                    onChange={() => {
                        if (table.getIsAllPageRowsSelected()) {
                            table.toggleAllPageRowsSelected(false);
                        } else {
                            table.toggleAllPageRowsSelected(true);
                        }
                    }}
                />
            </label>
        ),
        cell: ({ row }) => (
            <label style={{ display: "flex", width: "100%", justifyContent: "center", cursor: "pointer", boxShadow: "none" }}>
                <input
                    checked={row.getIsSelected()}
                    onChange={(event) => row.toggleSelected(event.target.checked)}
                    onClick={(e) => e.stopPropagation()}
                    aria-label="Select row"
                    type="checkbox"

                />
            </label>
        ),
        size: 4,
        minSize: 4,
        enableSorting: false,
        enableHiding: false,
    },
    {
        accessorKey: "invoiceNumber",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Number" table={table} />
        ),
        cell: ({ row }) => <div>{row.getValue("invoiceNumber")}</div>,
        size: 9,
        minSize: 9,
        enableSorting: false,
        enableHiding: false,
    },
    {
        accessorKey: "invoiceName",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Title" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div className="table-cell">
                    <span className="cell__text">
                        {row.getValue("invoiceName")}
                    </span>
                </div>
            )
        },
        size: 20,
        minSize: 20,
        enableSorting: true
    },
    {
        id: "status",
        accessorKey: "status",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Status" table={table} />
        ),
        cell: ({ row }) => {
            const status = row.getValue("status") as string;
            return (
                <div className={`${status} status`}>
                    <span>{status}</span>
                </div>
            )
        },
        filterFn: (row, id, value) => {
            return value.includes(row.getValue(id))
        },
        size: 18,
        minSize: 18,
        enableSorting: false
    },
    {
        accessorKey: "billTo",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Customer" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div>
                    {row.getValue("billTo")}
                </div>
            )
        },
        filterFn: (row, id, value) => {
            return value.includes(row.getValue(id))
        },
        size: 15.5,
        minSize: 15.5,
        enableSorting: true
    },
    {
        accessorKey: "dateIssued",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Issued" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div>
                    {row.getValue("dateIssued")}
                </div>
            )
        },
        size: 12.5,
        minSize: 12.5,
    },
    {
        accessorKey: "totalToPay",
        header: ({ column, table }) => (
            <DataTableColumnHeader column={column} title="Amount" table={table} />
        ),
        cell: ({ row }) => {
            return (
                <div>
                    {currenciesMap.get(row.original.currency)?.symbol}
                    {formatPrice(row.getValue("totalToPay"))}
                </div>
            )
        },
        size: 15.5,
        minSize: 15.5,
        enableSorting: true
    },
    {
        id: "actions",
        cell: ({ row, table }) => <InvoiceArchiveTableRowActions row={row} table={table} />,
        size: 7.5,
        minSize: 7.5,
    },
];

